// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { AvailableBranchesDataModel } from "@ces/App/Services/AvailableBranchesService";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export type AvailableBranchesStateModel = {
    data: AvailableBranchesDataModel | null;
};

const initialState: AvailableBranchesStateModel = {
    data: null,
};

const xAvailableBranches = createTypedReducerWithImmer(initialState, {
    "xAvailableBranches/CompleteLoad": (
        draft: Draft<AvailableBranchesStateModel>,
        action: { branches: AvailableBranchesDataModel },
    ) => {
        draft.data = action.branches!;
    },
});

(reducers as any).xAvailableBranches = xAvailableBranches;

export type xAvailableBranches = {
    xAvailableBranches: AvailableBranchesStateModel;
} & ApplicationState;

type AvailableBranchesReducer = {
    availableBranches: typeof xAvailableBranches;
};

export type AvailableBranchesActions =
    | Parameters<AvailableBranchesReducer[keyof AvailableBranchesReducer]>[1]
    | AnyAction;
